/**
 * Every alert group starts collapsed when the web notification settings
 * screen opens, per `.agents/views/43-notification-settings-levels.html`,
 * and expanding one leaves the others alone. This mirrors the mobile twin
 * `apps/mobile/src/notifications/alertGroupDisclosure.ts` (ISSUE-1032).
 */
import { type typeAlertGroup } from "./alertKindLabels";

export const INITIAL_EXPANDED_GROUPS: readonly typeAlertGroup[] = [];

export function isGroupExpanded({
  expandedGroups,
  group,
}: {
  expandedGroups: readonly typeAlertGroup[];
  group: typeAlertGroup;
}): boolean {
  return expandedGroups.includes(group);
}

export function toggleGroup({
  expandedGroups,
  group,
}: {
  expandedGroups: readonly typeAlertGroup[];
  group: typeAlertGroup;
}): typeAlertGroup[] {
  if (expandedGroups.includes(group)) {
    return expandedGroups.filter((candidate) => candidate !== group);
  }
  return [...expandedGroups, group];
}

export function alertGroupCountLabel(count: number): string {
  return count === 1 ? "1 alert" : `${count} alerts`;
}
